export const nullChecker = (value: any) => {
    return (value === undefined || value === 'undefined' || value === '' || value === null || value === 'null' || (Array.isArray(value) && !value.length));
};